import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;
export const API = `${BASE}/api`;

const client = axios.create({ baseURL: API });

client.interceptors.request.use((config) => {
  const token = localStorage.getItem("mt5_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Trading / state
export const getState = () => client.get("/state").then((r) => r.data);
export const getMarket = () => client.get("/market").then((r) => r.data);
export const postSignal = (payload) => client.post("/signals", payload).then((r) => r.data);
export const postAdvice = (payload) => client.post("/ai/advice", payload).then((r) => r.data);
export const postAdvisor = (payload) => client.post("/advisor", payload).then((r) => r.data);
export const postMode = (payload) => client.post("/mode", payload).then((r) => r.data);
export const postCommand = (payload) => client.post("/commands", payload).then((r) => r.data);
export const postAccountMode = (mode) => client.post("/account-mode", { mode }).then((r) => r.data);
export const getAiProviders = () => client.get("/ai/providers").then((r) => r.data);
export const askAi = (question) => client.post("/ai/ask", { question }).then((r) => r.data);
export const aiFillSignal = () => client.post("/ai/fill", {}).then((r) => r.data);
export const aiOneTap = (minConfidence = 0.7) => client.post("/ai/one-tap", { minConfidence }).then((r) => r.data);

// Auth
export const login = (payload) => client.post("/auth/login", payload).then((r) => r.data);
export const register = (payload) => client.post("/auth/register", payload).then((r) => r.data);
export const getMe = () => client.get("/auth/me").then((r) => r.data);
export const twofaSetup = () => client.post("/auth/2fa/setup").then((r) => r.data);
export const twofaEnable = (otp) => client.post("/auth/2fa/enable", { otp }).then((r) => r.data);
export const twofaDisable = (otp) => client.post("/auth/2fa/disable", { otp }).then((r) => r.data);
export const listUsers = () => client.get("/auth/users").then((r) => r.data);
export const createUser = (payload) => client.post("/auth/users", payload).then((r) => r.data);
export const approveUser = (email) => client.post(`/auth/users/${encodeURIComponent(email)}/approve`).then((r) => r.data);
export const suspendUser = (email) => client.post(`/auth/users/${encodeURIComponent(email)}/suspend`).then((r) => r.data);
export const deleteUser = (email) => client.delete(`/auth/users/${encodeURIComponent(email)}`).then((r) => r.data);

// Payments
export const paymentsConfig = () => client.get("/payments/config").then((r) => r.data);
export const createOrder = (payload) => client.post("/payments/order", payload).then((r) => r.data);
export const captureOrder = (orderId) => client.post("/payments/capture", { orderId }).then((r) => r.data);
export const paymentsHistory = () => client.get("/payments/history").then((r) => r.data);

export const errText = (e) => {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x.msg || JSON.stringify(x)).join(" ");
  return e?.response?.data?.error || e?.message || "Errore imprevisto";
};

export default client;
